import { DescriptionContentList as Container } from './styles'

export function DescriptionContentList({ children }) {
  return <Container>{children}</Container>
}
